import { Injectable } from '@angular/core';
import { Model, ModelMapperInterface } from '@web-portal/domains/shared/domain-models';
import { getLatestRevision } from 'utilities';

@Injectable()
export class ModelMapper implements ModelMapperInterface<Model> {
  mapToModel(modelData: Model): Model {
    return {
      ...modelData,
      latestRevision: getLatestRevision(modelData),
    };
  }
}
